import { IconName } from '@betterment/samba-react';

import { urlBuilder } from '../../../Shared/urlBuilder';

export type OwnershipOptionConfig = {
  name: string;
  icon: IconName;
  legalAccountType: 'individual_taxable' | 'joint_taxable' | 'trust_taxable';
  getPath: (hasExistingAccount: boolean, hasSdiAccount: boolean, securityLendingStatus: string | null) => string;
};

const getNextPath = (hasSdiAccount: boolean, securityLendingStatus: string | null): string => {
  if (hasSdiAccount) {
    if (securityLendingStatus === 'NEVER_ENROLLED') {
      return urlBuilder.appAddAccountDirectTradingTermsAndAgreements.path;
    }

    return urlBuilder.appAddAccountDirectTradingConfirmation.path;
  }

  return urlBuilder.appAddAccountDirectTradingInvestingExperience.path;
};

export const ownershipOptions: Record<string, OwnershipOptionConfig> = {
  'Individual account': {
    name: 'Individual account',
    icon: 'Person',
    legalAccountType: 'individual_taxable',
    getPath: (_hasExistingAccount, hasSdiAccount, securityLendingStatus) =>
      getNextPath(hasSdiAccount, securityLendingStatus),
  },
  'Joint account': {
    name: 'Joint account',
    icon: 'People',
    legalAccountType: 'joint_taxable',
    getPath: (hasExistingAccount, hasSdiAccount, securityLendingStatus) =>
      hasExistingAccount
        ? getNextPath(hasSdiAccount, securityLendingStatus)
        : urlBuilder.appAddAccountDirectTradingJointAccount.path,
  },
  'Existing trust': {
    name: 'Existing trust',
    icon: 'Safe',
    legalAccountType: 'trust_taxable',
    getPath: (hasExistingAccount, hasSdiAccount, securityLendingStatus) =>
      hasExistingAccount
        ? getNextPath(hasSdiAccount, securityLendingStatus)
        : urlBuilder.appAddAccountDirectTradingTrustAccount.path,
  },
};
